import { Injectable } from '@angular/core';
import { AutoTopupStore } from './auto-topup.store';
import { Query } from '@datorama/akita';
import { AutoTopUpSubscriptionModel } from './models/auto-top-up-subscription.model';

@Injectable({ providedIn: 'root' })
export class AutoTopupQuery extends Query<AutoTopUpSubscriptionModel> {

  constructor(protected store: AutoTopupStore) {
    super(store);
  }

}
